import { render, staticRenderFns } from "./IconGoogleG.vue?vue&type=template&id=03e72ecc&"
import script from "./IconGoogleG.vue?vue&type=script&lang=js&"
export * from "./IconGoogleG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports